import { Car, MessageCircle, Key } from "lucide-react";

export const DASHowItWorks = () => {
  return (
    <section id="how-it-works" className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-black mb-4">
            So funktioniert's
          </h2>
          <p className="text-lg md:text-xl text-gray-700">In 3 einfachen Schritten zum Mietwagen</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
          <div className="text-center">
            <div className="bg-gray-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Car className="h-10 w-10 text-gold" />
            </div>
            <h3 className="font-heading font-bold text-xl mb-2">1. Fahrzeug wählen</h3>
            <p className="text-gray-700">
              Wählen Sie Ihr Wunschfahrzeug aus unserer Flotte
            </p>
          </div>

          <div className="text-center">
            <div className="bg-gray-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
              <MessageCircle className="h-10 w-10 text-gold" />
            </div>
            <h3 className="font-heading font-bold text-xl mb-2">2. Auf WhatsApp senden</h3>
            <p className="text-gray-700">
              Senden Sie Ihre Anfrage direkt über WhatsApp
            </p>
          </div>

          <div className="text-center">
            <div className="bg-gray-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Key className="h-10 w-10 text-gold" />
            </div>
            <h3 className="font-heading font-bold text-xl mb-2">3. Abholen & losfahren</h3>
            <p className="text-gray-700">
              Fahrzeug abholen, kurze Inspektion, Übergabeformular – fertig!
            </p>
          </div>
        </div>

        <div className="mt-12 text-center text-sm text-gray-700 max-w-2xl mx-auto space-y-3">
          <p>
            <strong>Hinweis:</strong> Voll-zu-voll Tankregelung. Bei Übergabe erfolgt eine kurze 
            Fahrzeuginspektion und Ausfüllung des Übergabeformulars.
          </p>
          <p>
            <strong>Lieferservice:</strong> Auf Wunsch liefern wir Ihr Fahrzeug gegen einen kleinen 
            Aufpreis auch direkt zu Ihnen. Die Kosten können individuell vereinbart werden.
          </p>
        </div>
      </div>
    </section>
  );
};
